var map = {
	"./bracelet_1.svg": 71364,
	"./earring_1.svg": 47146,
	"./earring_2.svg": 91545,
	"./jlux_1.svg": 95145,
	"./jlux_2.svg": 10682,
	"./jlux_3.svg": 41643,
	"./jlux_4.svg": 36964,
	"./jlux_5.svg": 88133,
	"./jlux_6.svg": 65702,
	"./mens_ring_1.svg": 36952,
	"./pendant_1.svg": 47910,
	"./ring_1.svg": 36562,
	"./ring_2.svg": 25249,
	"./ring_3.svg": 13008,
	"./ring_4.svg": 78895,
	"./ring_5.svg": 16318,
	"./ring_6.svg": 70493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17974;